import React from 'react'
import EllipsesSVG from "../../../assets/icons/ellipses.svg"
export const Ellipses: React.FC = () => {
  return (
    <img src={EllipsesSVG} alt="" className="w-[21px] h-[5px] cursor-pointer" />
  )
}
